import { z } from 'zod'

import { agentSessionSchema } from './agentSession.ts'

// POST /api/agent/gateway/sessions の応答（201）
export const createSessionResponseSchema = z.object({
  agentSession: agentSessionSchema,
})

export type CreateSessionResponse = z.infer<typeof createSessionResponseSchema>

// GET /api/agent/gateway/sessions のクエリ。範囲は salescore-agent-storage の listSessions に合わせる
export const listSessionsQuerySchema = z.object({
  // 1ページの件数。省くと storage の既定（20件）
  limit: z.coerce.number().int().min(1).max(100).optional(),
  // 前のページの応答の nextCursor。省くと最初のページ
  cursor: z.string().optional(),
})

// GET /api/agent/gateway/sessions の応答。セッションは更新日時の新しい順に並ぶ
export const listSessionsResponseSchema = z.object({
  sessions: z.array(agentSessionSchema),
  // 続きがなければ null
  nextCursor: z.string().nullable(),
})

export type ListSessionsResponse = z.infer<typeof listSessionsResponseSchema>
